import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-button-back__text" }

import ArrowLeftIcon from '@/components/commons/icons/ArrowLeftIcon.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomButtonBack',
  emits: ['click'],
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "custom-button-back",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createVNode(ArrowLeftIcon, { class: "custom-button-back__icon" }),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})